<script lang="ts">import { rankRowsFomo, rankRowsTurbo, ranksDataFomo, ranksDataTurbo } from "../data";
import Included from "../icons/included.svelte";
import { getVerbiageKey, getVerbiageKeyWithPrefix } from "../utils";
import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile } from "@infinitro/global";
export let isPadding = true;
const rewardsTableKeyPrefix = $stateUi.vip.rewardsTableKeyPrefix;
$: useSummaryRewardsTable2 = $stateUi.vip.rewardsTableLayout === "summary2";
$: ranksData = useSummaryRewardsTable2 ? ranksDataTurbo : ranksDataFomo;
$: baseRows = useSummaryRewardsTable2 && rewardsTableKeyPrefix ? rankRowsTurbo.map((a) => {
	return {
		...a,
		name: Verbiage[getVerbiageKeyWithPrefix(rewardsTableKeyPrefix, a.name)]
	};
}) : rankRowsFomo.map((a) => {
	return {
		...a,
		name: Verbiage[getVerbiageKey(a.name)]
	};
});
$: useExpandedRankPresentation = $stateUi.layout?.useExpandedRankPresentation ?? false;
$: rows = useExpandedRankPresentation ? [{
	name: Verbiage[getVerbiageKey("wagering_required")],
	id: "wagering-required"
}, ...baseRows] : baseRows;
</script>

<div class="vip-rank-rewards" class:pending2rem={!$isMobile && isPadding}>
	<div class="vip-rank-rewards-container">
		<div class="table-container">
			<div class="ranks-reward-table">
				<div class="table-header">
					{#each ranksData as rank, i}
						<div class="header-cell">
							{#if useSummaryRewardsTable2}
								{$t(
									Verbiage[getVerbiageKeyWithPrefix(`${rewardsTableKeyPrefix}_rank`, rank.badge)]
								)}
							{:else}
								{$t(Verbiage['rank'])}
								{i + 1}
							{/if}
						</div>
					{/each}
				</div>
				<div class="table-body">
					<div class="table-side" class:table-side-summaryRewardsTable2={useSummaryRewardsTable2}>
						{#if useSummaryRewardsTable2}
							<div
								class="side-cell side-cell-blur"
								class:side-cell-summaryRewardsTable2={useSummaryRewardsTable2}
							></div>
						{/if}
						{#each rows as row, i}
							<div
								class="side-cell"
								class:cell-bg={i % 2 === 0}
								class:side-cell-summaryRewardsTable2={useSummaryRewardsTable2}
							>
								{@html $t(row.name)}
							</div>
						{/each}
					</div>
					<div class="table-content">
						{#each rows as row, i}
							{#if row.id === 'wagering-required' && useExpandedRankPresentation}
								<div class="content-row" class:cell-bg={i % 2 === 0}>
									{#each ranksData as rank}
										<div class="content-cell">
											<div class="content-cell">{rank.amount}</div>
										</div>
									{/each}
								</div>
							{:else}
								<div class="content-row" class:cell-bg={i % 2 === 0}>
									{#each ranksData as rank}
										<div class="content-cell">
											{#if rank.rewards.includes(row.id)}
												<Included />
											{/if}
										</div>
									{/each}
								</div>
							{/if}
						{/each}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<style>
	.pending2rem {
		padding: 2rem;
}

	.vip-rank-rewards {
		margin-top: 1rem;
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
}

	.vip-rank-rewards-badge {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.25rem;
		border-radius: 9999px;
		padding-left: 1rem;
		padding-right: 1rem;
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
		background: var(--gradient-main);
}

	.vip-rank-rewards-container {
		position: relative;
		max-width: 92vw;
}

	@media (min-width: 1024px) {

		.vip-rank-rewards-container {
				width: 100%;
		}
}

	.table-container {
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: thin;
		scrollbar-color: var(--color-neutral-900) var(--color-background-900);
}

	.table-container::-webkit-scrollbar {
		height: 0.5rem;
		width: 0.5rem;
		background-color: transparent;
		display: block;
}

	.table-container::-webkit-scrollbar-track {
		background-color: var(--color-background-900);
}

	.table-container::-webkit-scrollbar-thumb {
		border-radius: 0.5rem;
		background-color: var(--color-neutral-900);
		--tw-shadow-color: var(--shadow-neutral);
		--tw-shadow: var(--tw-shadow-colored);
}

	@media (max-width: 768px) {
		.table-container {
			overflow-x: scroll;
			-ms-overflow-style: -ms-autohiding-scrollbar;
		}

		.table-container::-webkit-scrollbar {
			-webkit-appearance: none;
			height: 4px;
		}
	}

	.ranks-reward-table {
		width: 100%;
		min-width: 1200px;
		border-radius: 0.5rem;
		background-color: var(--component-about-vip-vip-rank-rewards-table-bg,unset);
}
	@media (min-width: 1024px) {
		.ranks-reward-table {
				min-width: 0px;
		}
	}

	.table-header {
		display: flex;
		height: 40px;
		align-items: center;
		justify-content: space-between;
		border-top-left-radius: 0.5rem;
		border-top-right-radius: 0.5rem;
		background-color: var(--component-about-vip-vip-rank-rewards-table-header-bg);
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		padding-left: 105px;
		padding-right: 5px;
		z-index: 5;
		position: relative;
}

	.header-cell {
		display: flex;
		width: 9%;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 0.125rem;
		font-size: 0.75rem;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
		text-align: center;
}

	.badge-container {
		display: flex;
		height: 1.5rem;
		width: 1rem;
		align-items: center;
		justify-content: center;
}

	.table-body {
		display: flex;
}

	.table-side {
		display: flex;
		width: 100px;
		flex-direction: column;
		gap: 0.5rem;
		border-top-left-radius: 0.5rem;
		border-bottom-left-radius: 0.5rem;
		background-color: var(--component-about-vip-vip-rank-rewards-table-side-bg);
		padding-bottom: 1rem;
		position: absolute;
		z-index: 10;
		transform: translateX(-1px);
		top: 0rem;
		padding-top: 2.5rem;
}

	.side-cell {
		display: flex;
		height: 40px;
		align-items: center;
		justify-content: flex-start;
		padding-left: 0.5rem;
		font-size: 0.75rem;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
		line-height: 14px;
}

	.side-cell-blur {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100px;
}

	@media (min-width: 1024px) {

		.side-cell-blur {
				display: none;
		}
}

	.side-cell-summaryRewardsTable2 {
		--tw-backdrop-blur: blur(12px);
		backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

	@media (min-width: 1024px) {

		.side-cell-summaryRewardsTable2 {
				--tw-backdrop-blur:  ;
				backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
		}
}

	.side-cell:last-child {
		height: 20px;
}

	.side-cell-summaryRewardsTable2:last-child {
		height: 40px;
}

	.table-content {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 0.5rem;
}

	.content-row {
		display: flex;
		height: 40px;
		align-items: center;
		justify-content: space-between;
		padding-left: 105px;
}

	.content-row:nth-child(odd) {
		background-color: var(--component-about-vip-vip-rank-rewards-odd-row-bg,transparent) !important;
}

	.content-cell {
		display: flex;
		width: 9.5%;
		align-items: center;
		justify-content: center;
		padding: 0.5rem;
		text-align: left;
		font-size: 0.75rem;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
}
</style>
